<template>
  <div>
    <Pos_add_product_data/>
  </div>
</template>

<script>
import Pos_add_product_data from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_add_product_data";
export default {
  name: "PosAddProductData",
  components: {
    Pos_add_product_data
  }
}
</script>

<style scoped>

</style>
